import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import moment from 'moment';

import Picker, { SKIN_TONE_MEDIUM_DARK } from "emoji-picker-react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane , faSmile } from '@fortawesome/free-solid-svg-icons'

// const element = <FontAwesomeIcon icon={faPaperPlane} />



function InputBox() {

    const socket = useSelector(state => state.socket)
    const [message, setMessage] = useState('');
    const InputRef = useRef(null);
    const [pickemoji, setPickemoji] = useState(false);

    
    
    const onEmojiClick = (event, emojiObject) => {
        setMessage(message + emojiObject.emoji)
    };
    
    
        let emoji_picker_content=<></>;
        if (pickemoji) {
                emoji_picker_content = <Picker
                onEmojiClick={onEmojiClick}
                disableAutoFocus={true}
                skinTone={SKIN_TONE_MEDIUM_DARK}
                groupNames={{ smileys_people: "PEOPLE" }}
                native />
        }


    const sendHandler = () => {
        if (message.trim() !== "") {
            const date = moment().format("HH:MM A")
            socket.emit("sendMessage", { message, date })
            InputRef.current.focus();
            setMessage('');
        }
    }

    return (
        <div className="input-box-container">
            <div className = "emoji-picker-container">
                {emoji_picker_content}
            </div>
            <input
                ref={InputRef}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={(e) => { return e.key === 'Enter' ? sendHandler() : null }}
                className="chat-input"
                placeholder="Type your message">
            </input>
            <div 
              onClick = {() => setPickemoji(!pickemoji)}
                className ="choose-emoji-container">
                <FontAwesomeIcon icon={faSmile} />
            </div>
            <button
                onClick={sendHandler}
                className="send-button">SEND
                <FontAwesomeIcon className="send-icon" icon={faPaperPlane} />
            </button>
        </div>
    )
}

export default InputBox
